// edit-input.styles.ts
import styled from "@emotion/styled";

export const InputWrapper = styled.div`
    width: 100%;
    position: relative;
    opacity: 1;
`;

export const StyledInput = styled.input`
    width: 100%;
    height: 48px;
    padding-top: 8px;
    padding-right: 16px;
    padding-bottom: 8px;
    padding-left: 16px;
    border-radius: 9.42px;
    border-width: 1px;
    border-style: solid;
    border-color: #2b2d33;
    background: #23252a;

    font-family:
        "Inter",
        system-ui,
        -apple-system,
        BlinkMacSystemFont,
        sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 120%;
    letter-spacing: 0px;
    vertical-align: middle;
    color: #e9ecf5;

    outline: none;
    box-sizing: border-box;

    &::placeholder {
        font-family: inherit;
        font-weight: 500;
        font-size: 16px;
        line-height: 120%;
        letter-spacing: 0px;
        color: #e9ecf5;
    }

    /* ✅ Chrome/Safari autofill fix (pre-filled / password manager / paste suggestions) */
    &:-webkit-autofill,
    &:-webkit-autofill:hover,
    &:-webkit-autofill:focus,
    &:-webkit-autofill:active {
        -webkit-text-fill-color: #e9ecf5 !important;
        caret-color: #e9ecf5;
        -webkit-box-shadow: 0 0 0px 1000px #23252a inset !important;
        box-shadow: 0 0 0px 1000px #23252a inset !important;
        background-clip: content-box !important;
        transition: background-color 9999s ease-out 0s;
    }

    &:focus {
        /* Keep border width the same to avoid layout shift */
        border-color: #5e84ed;
        /* Extra 1px ring to visually match a 2px border */
        box-shadow: 0 0 0 1px #5e84ed;
    }
`;

export const EditIconButton = styled.button`
    position: absolute;
    top: 50%;
    right: 14px;
    transform: translateY(-50%);
    padding-top: 12px;
    padding-bottom: 12px;
    padding-right: 0px;
    padding-left: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    border: none;
    background: transparent;
    cursor: pointer;

    img {
        display: block;
    }

    /* Hide the icon button when the input is focused */
    ${StyledInput}:focus + & {
        display: none;
    }
`;
